<nb-card class="dashboard-card-scroll">
	<nb-card-header>
		<h4> <ngx-header-title> Project Management </ngx-header-title> </h4>
	</nb-card-header>
	<nb-card-body>
		This tab will show project management charts and aggregated data.
	</nb-card-body>
</nb-card>
